import { getSimpleBranchingQuery, getSimpleSubjectQuery } from '@iotv/datamodel-core';
import { AdjacentType } from '@iotv/iotv-v3-types';
/** Where `Customer` is the context defining object */
const customerSubjectQuery = getSimpleSubjectQuery('Customer');
const customerToPropertyQuery = getSimpleBranchingQuery('Customer', 'Property', AdjacentType.CHILD);
const propertyToAreaQuery = getSimpleBranchingQuery('Property', 'Area', AdjacentType.CHILD);
const propertyToPlace = getSimpleBranchingQuery('Property', 'Place', AdjacentType.CHILD);
const areaToAreaQuery = getSimpleBranchingQuery('Area', 'Area', AdjacentType.CHILD);
const areaToPlaceQuery = getSimpleBranchingQuery('Area', 'Place', AdjacentType.CHILD);
areaToAreaQuery.addSubQuery(areaToPlaceQuery);
areaToAreaQuery.addSubQuery(areaToAreaQuery);
propertyToAreaQuery.addSubQuery(areaToPlaceQuery);
propertyToAreaQuery.addSubQuery(areaToAreaQuery);
customerToPropertyQuery.addSubQuery(propertyToPlace);
customerToPropertyQuery.addSubQuery(propertyToAreaQuery);
customerSubjectQuery.addSubQuery(customerToPropertyQuery);
export { customerSubjectQuery as CustomerPropertyAreaPlaceQuery };
